
// export const createContactDetails = (cd) => {
// 	// console.log('Creating Contact Details', createContact(contact));
// 	return cd;
// }

export const createContactDetails = ({
	currency = createCurrency({}),
	section = undefined,
	template_widgets_contact_relations_standard = '',
	file_relation_external_table = '',
	template_group_table = '',
	client = createClient({}),
	action = '',
	related_groups = [createRelated_groups({})],
	payment_methods = [createPayment_methods({})],
	contact_relations_template_type = '',
	booking = 0,
	external_table = '',
	user = createUser({}),
	contact = createContact({}),
	external_id = 0,
	documents = [],
	files = [createFiles({})],
	countries = [''],
	contact_relations = [createContact_relations({})],
	contact_search_type = '',
	file_relation_external_id = 0,
	tax_types = [createTax_types({})],
	currencies = [createCurrencies({})],
	template_documents_table = '',
	template_contact_files = '',
	contact_id = 0,
	related_documents = [createRelated_documents({})],
	additional_infos = [],
	fields = [createFields({})],
	languages = [['']],
	label = 0,
	promoter = undefined
} = {}) => {
	// console.log('Creating Contact Details', createContact(contact));

	return {
		currency: createCurrency(currency || undefined),
		section,
		template_widgets_contact_relations_standard,
		file_relation_external_table,
		template_group_table,
		client: createClient(client),
		action,
		related_groups: related_groups.map(createRelated_groups),
		payment_methods: payment_methods.map(createPayment_methods),
		contact_relations_template_type,
		booking,
		external_table,
		user: createUser(user),
		contact: createContact(contact),
		external_id,
		documents,
		files: files.map(createFiles),
		countries,
		contact_relations: contact_relations.map(createContact_relations),
		contact_search_type,
		file_relation_external_id,
		tax_types: tax_types.map(createTax_types),
		currencies: currencies.map(createCurrencies),
		template_documents_table,
		template_contact_files,
		contact_id,
		related_documents: related_documents.map(createRelated_documents),
		additional_infos,
		fields: fields.map(createFields),
		languages,
		label,
		promoter
	}
};

const createContact_relations = ({
	is_company = 0,
	passport_no = undefined,
	contact_name = '',
	relation = '',
	contact_id = 0,
	email1 = '',
	phone2 = undefined,
	phone1 = undefined,
	contract_flag = undefined,
	main_company_flag = undefined,
	birthdate = undefined,
	main_contact_for_artist_flag = undefined,
	last_modified = '',
	contact_relation_id = 0,
	travel_flag = undefined,
	request_flag = undefined
} = {}) => {
	return {
		is_company,
		passport_no,
		contact_name,
		relation,
		contact_id,
		email1,
		phone2,
		phone1,
		contract_flag,
		main_company_flag,
		birthdate,
		main_contact_for_artist_flag,
		last_modified,
		contact_relation_id,
		travel_flag,
		request_flag
	}
};


const createCurrency = ({
	currency_k_sep = undefined,
	currency_minus_trailing = undefined,
	currency_minus_leading = undefined,
	currency_sign = '',
	last_modified = '',
	currency_decimals = undefined,
	currency_iso = '',
	created = '',
	currency_d_sep = undefined,
	currency_id = 0,
	currency_name = '',
	exchange_rate = 0,
	currency_sign_type = undefined
} = {}) => {
	return {
		currency_k_sep,
		currency_minus_trailing,
		currency_minus_leading,
		currency_sign,
		last_modified,
		currency_decimals,
		currency_iso,
		created,
		currency_d_sep,
		currency_id,
		currency_name,
		exchange_rate,
		currency_sign_type
	}
};



const createClient = ({
	display_name = ''
} = {}) => {
	return {
		display_name
	}
};



const createRelated_groups = ({
	group_name = '',
	group_id = 0
} = {}) => {
	return {
		group_name,
		group_id
	}
};



const createPayment_methods = ({
	payment_method_name = '',
	created = '',
	payment_method_id = 0,
	auto_paid = undefined,
	last_modified = ''
} = {}) => {
	return {
		payment_method_name,
		created,
		payment_method_id,
		auto_paid,
		last_modified
	}
};



const createUser = ({
	publishing_flag = 0,
	booking_flag = 0,
	job_title = undefined,
	booking_more_flag = 0,
	permissions,
	user_name = '',
	staff_email = '',
	signature_link = undefined,
	module_settings_flag = 0,
	management_flag = 0,
	general_settings_flag = 0,
	smtp_password = undefined,
	contact_id = undefined,
	created = '',
	publishing_more_flag = 0,
	staff_phone2 = undefined,
	distribution_flag = 0,
	promotion_flag = 0,
	staff_fullname = undefined,
	user_settings_flag = 0,
	accounting_more_flag = 0,
	dashboard_settings = createDashboard_settings(),
	user_id = 0,
	contacts_flag = 0,
	smtp_username = undefined,
	password = '',
	label_flag = 0,
	client_code = undefined,
	label_more_flag = 0,
	language = '',
	staff_phone1 = undefined,
	contact_export_import_flag = 0,
	booking_report_flag = 0,
	last_modified = '',
	general_flag = 0,
	accounting_flag = 0,
	smtp_server = undefined,
	general_more_flag = 0
} = {}) => {
	return {
		publishing_flag,
		booking_flag,
		job_title,
		booking_more_flag,
		permissions,
		user_name,
		staff_email,
		signature_link,
		module_settings_flag,
		management_flag,
		general_settings_flag,
		smtp_password,
		contact_id,
		created,
		publishing_more_flag,
		staff_phone2,
		distribution_flag,
		promotion_flag,
		staff_fullname,
		user_settings_flag,
		accounting_more_flag,
		dashboard_settings: createDashboard_settings(dashboard_settings),
		user_id,
		contacts_flag,
		smtp_username,
		password,
		label_flag,
		client_code,
		label_more_flag,
		language,
		staff_phone1,
		contact_export_import_flag,
		booking_report_flag,
		last_modified,
		general_flag,
		accounting_flag,
		smtp_server,
		general_more_flag
	}
};

const createDashboard_settings = () => {
	return {

	}
};




const createContact = (payload = {}) => {
	const {
		url2 = undefined,
		chat3 = '',
		phone1 = '',
		date_start = undefined,
		invoice_end_of_month_flag = 0,
		default_declaration_text1 = undefined,
		creditor_no = 0,
		vat_no = 0,
		last_name = '',
		iban = '',
		city = '',
		bank_name = '',
		fax2 = undefined,
		iCal_password = undefined,
		skype = undefined,
		country = '',
		language = '',
		invoice_payment_method_id = 0,
		mobile1 = '',
		default_declaration_text2 = undefined,
		last_modified = '',
		valid_vat_no_flag = 0,
		gender = undefined,
		email1 = '',
		cost_discount_days = 0,
		request = '',
		tax_no = 0,
		nick_name = '',
		mobile2 = undefined,
		cost_payment_method_id = 0,
		contact_id = 0,
		invoice_discount_days = 0,
		url3 = undefined,
		cost_discount_percent = 0,
		main_promoter = undefined,
		account_holder = '',
		vat_type_id = undefined,
		sortcode = 0,
		birthdate = undefined,
		region = '',
		invoice_due_days = 0,
		bank_address = '',
		cost_due_days = 0,
		swift = '',
		postbox = undefined,
		url4 = undefined,
		aim = undefined,
		title = undefined,
		cost_end_of_month_flag = undefined,
		customer_no = 0,
		invoice_discount_percent = 0,
		currency_id = 0,
		company_legalname = undefined,
		address2 = '',
		notes = '',
		formality = undefined,
		url1 = '',
		postalcode = '',
		email2 = '',
		cost_center = undefined,
		fax1 = 0,
		passport_no = undefined,
		address1 = '',
		account_no = 0,
		phone2 = '',
		company_name = undefined,
		date_end = undefined,
		debitor_no = 0,
		created = '',
		first_name = '',
		vat_no_confirmed = undefined
	} = payload;
	return {
		...payload,

		url2,
		chat3,
		phone1,
		date_start,
		invoice_end_of_month_flag,
		default_declaration_text1,
		creditor_no,
		vat_no,
		last_name,
		iban,
		city,
		bank_name,
		fax2,
		iCal_password,
		skype,
		country,
		language,
		invoice_payment_method_id,
		mobile1,
		default_declaration_text2,
		last_modified,
		valid_vat_no_flag,
		gender,
		email1,
		cost_discount_days,
		request,
		tax_no,
		nick_name,
		mobile2,
		cost_payment_method_id,
		contact_id,
		invoice_discount_days,
		url3,
		cost_discount_percent,
		main_promoter,
		account_holder,
		vat_type_id,
		sortcode,
		birthdate,
		region,
		invoice_due_days,
		bank_address,
		cost_due_days,
		swift,
		postbox,
		url4,
		aim,
		title,
		cost_end_of_month_flag,
		customer_no,
		invoice_discount_percent,
		currency_id,
		company_legalname,
		address2,
		notes,
		formality,
		url1,
		postalcode,
		email2,
		cost_center,
		fax1,
		passport_no,
		address1,
		account_no,
		phone2,
		company_name,
		date_end,
		debitor_no,
		created,
		first_name,
		vat_no_confirmed,

		getName: () => first_name ? `${first_name} ${last_name}` : (company_name ? `${company_name}` : ''),
		getExternalTable: () => first_name ? `contacts_individual` : `contacts`
	}
};

export const getName = (payload = {}) => {
	if (!payload) {
		return undefined;
	}
	const {
		first_name,
		last_name,
		company_name
	} = payload;
	return (first_name || last_name) ? `${first_name ? first_name + ' ' : ''}${last_name ? last_name : ''}` : `${company_name}`;
}

const createFiles = (file) => {
	return {
		file_description: file.file_description,
		file_name: file.file_name,
		file_relation_id: file.file_relation_id,
		md: file.md,
		file_path: file.file_path,
		last_modified: file.last_modified,
		'public': file.public,
		file_type: file.file_type,
		file_id: file.file_id
	}
};



const createTax_types = ({
	last_modified = '',
	created = '',
	tax_rate_percent = 0,
	target_country = '',
	vat_type = 0,
	tax_deduction_flag = 0,
	tax_type_id = 0,
	tax_description = '',
	tax_name = ''
} = {}) => {
	return {
		last_modified,
		created,
		tax_rate_percent,
		target_country,
		vat_type,
		tax_deduction_flag,
		tax_type_id,
		tax_description,
		tax_name
	}
};



const createCurrencies = ({
	currency_minus_trailing = undefined,
	currency_minus_leading = undefined,
	currency_sign = '',
	currency_k_sep = undefined,
	currency_id = 0,
	currency_name = '',
	exchange_rate = 0,
	currency_sign_type = undefined,
	last_modified = '',
	currency_decimals = undefined,
	created = '',
	currency_iso = '',
	currency_d_sep = undefined
} = {}) => {
	return {
		currency_minus_trailing,
		currency_minus_leading,
		currency_sign,
		currency_k_sep,
		currency_id,
		currency_name,
		exchange_rate,
		currency_sign_type,
		last_modified,
		currency_decimals,
		created,
		currency_iso,
		currency_d_sep
	}
};



const createRelated_documents = (doc) => {
	return {
		file_description: doc.file_description,
		file_name: doc.file_name,
		file_relation_id: doc.file_relation_id,
		md: doc.md,
		file_path: doc.file_path,
		last_modified: doc.last_modified,
		'public': doc.public,
		file_type: doc.file_type,
		file_id: doc.file_id
	}
};



const createFields = ({
	custom_field_id = 0,
	last_modified = '',
	external_table = '',
	created = '',
	field_label = '',
	data = '',
	custom_data_id = 0,
	external_id = 0
} = {}) => {
	return {
		custom_field_id,
		last_modified,
		external_table,
		created,
		field_label,
		data,
		custom_data_id,
		external_id
	}
};

//#region  

// const demoContactsDetails = {
// 	"section": null,
// 	"file_relation_external_table": "contacts",
// 	"template_widgets_contact_relations_standard": "/srv/www/htdocs/TEMPLATES/widgets_contact_relations_standard.htm",
// 	"currency": {
// 		"currency_k_sep": null,
// 		"currency_sign": "€",
// 		"currency_minus_leading": null,
// 		"currency_minus_trailing": null,
// 		"currency_d_sep": null,
// 		"currency_iso": "EUR",
// 		"created": "2007-07-30 10:22:03",
// 		"currency_decimals": null,
// 		"last_modified": "2018-03-05 17:43:10",
// 		"currency_sign_type": null,
// 		"exchange_rate": 1,
// 		"currency_id": 2,
// 		"currency_name": "EURO"
// 	},
// 	"external_table": "contacts",
// 	"user": {
// 		"label_more_flag": 1,
// 		"client_code": null,
// 		"smtp_username": null,
// 		"label_flag": 1,
// 		"password": "5a9e43db1072205ae13f823d7ba94fb1",
// 		"user_id": 122,
// 		"dashboard_settings": "{\"1\":{\"w\":6,\"metric_id\":\"1\",\"x\":6,\"y\":0,\"chart_type\":\"pie-chart\",\"allowed\":\"1\",\"h\":14,\"title\":\"Agreed Vs Not-agreed Contracts\",\"i\":\"1\"},\"4\":{\"w\":6,\"metric_id\":\"4\",\"x\":0,\"default\":1,\"y\":0,\"chart_type\":\"list-grid\",\"allowed\":\"1\",\"h\":14,\"title\":\"Upcoming Events\",\"i\":\"4\"},\"3\":{\"w\":6,\"default\":1,\"x\":0,\"metric_id\":\"3\",\"y\":0,\"chart_type\":\"bar-chart\",\"allowed\":\"1\",\"h\":14,\"title\":\"Amount Of Bookings Per User\",\"i\":\"3\"},\"2\":{\"w\":6,\"x\":0,\"metric_id\":\"2\",\"y\":0,\"chart_type\":\"doughnut-chart\",\"allowed\":\"1\",\"h\":14,\"title\":\"Paid Vs Open Invoices\",\"i\":\"2\"}}",
// 		"accounting_more_flag": 1,
// 		"contacts_flag": 1,
// 		"user_settings_flag": 1,
// 		"general_more_flag": 1,
// 		"smtp_server": null,
// 		"accounting_flag": 1,
// 		"general_flag": 1,
// 		"booking_report_flag": "1",
// 		"last_modified": "2019-04-30 14:39:29",
// 		"contact_export_import_flag": "1",
// 		"staff_phone1": null,
// 		"language": "en",
// 		"module_settings_flag": 1,
// 		"signature_link": null,
// 		"general_settings_flag": 1,
// 		"management_flag": "1",
// 		"user_name": "noman",
// 		"permissions": "{\"allowed\":{\"roles\":[\"admin\"]},\"blocked\":{\"tabs\":[\"accounting_invoices_overview\",\"accounting_reports_booking\",\"accounting_costs_royalty_accounts\",\"accounting_invoices_forwarding\",\"accounting_invoices_invoice_lines\",\"accounting_invoices_payments\",\"accounting_reports_invoice\",\"accounting_costs_assign_projects\",\"booking_calendar_map\",\"accounting_invoices_unlock\",\"accounting_costs_overview\"],\"sub_menu\":[\"accounting_costs\",\"accounting_plugins\",\"accounting_invoice_reminder\",\"accounting_invoices\",\"accounting_reports\"]}}",
// 		"staff_email": "",
// 		"booking_flag": 1,
// 		"job_title": null,
// 		"booking_more_flag": 1,
// 		"publishing_flag": 1,
// 		"distribution_flag": 1,
// 		"staff_fullname": null,
// 		"promotion_flag": "1",
// 		"created": "2019-02-13 11:36:42",
// 		"staff_phone2": null,
// 		"publishing_more_flag": 1,
// 		"contact_id": null,
// 		"smtp_password": null
// 	},
// 	"contact": {
// 		"invoice_discount_percent": "12.00",
// 		"currency_id": 2,
// 		"company_legalname": null,
// 		"title": null,
// 		"cost_end_of_month_flag": null,
// 		"customer_no": "423",
// 		"postbox": null,
// 		"aim": null,
// 		"url4": null,
// 		"birthdate": null,
// 		"invoice_due_days": 54,
// 		"region": "Dhakaganj",
// 		"cost_due_days": 41,
// 		"bank_address": "Gudarghat",
// 		"swift": "Apple",
// 		"company_name": null,
// 		"date_end": null,
// 		"created": "2010-07-02 14:06:09",
// 		"debitor_no": "523",
// 		"first_name": "Barbara",
// 		"vat_no_confirmed": null,
// 		"fax1": "13231",
// 		"cost_center": null,
// 		"passport_no": null,
// 		"address1": "13 Orchard Str",
// 		"account_no": "1231",
// 		"phone2": "0342156465136456",
// 		"postalcode": "NW103Q",
// 		"email2": "s2ndemail@gmail.com",
// 		"address2": "2nd street, First area",
// 		"notes": "Note is cool",
// 		"url1": "www.url.com",
// 		"formality": null,
// 		"mobile1": "",
// 		"default_declaration_text2": null,
// 		"gender": null,
// 		"last_modified": "2019-05-09 14:50:03",
// 		"valid_vat_no_flag": 0,
// 		"skype": null,
// 		"country": "United Kingdom",
// 		"language": "de",
// 		"invoice_payment_method_id": 4,
// 		"city": "London",
// 		"bank_name": "ABBL",
// 		"fax2": null,
// 		"iCal_password": null,
// 		"url2": null,
// 		"chat3": "skawp",
// 		"date_start": null,
// 		"phone1": "56436136549841321",
// 		"invoice_end_of_month_flag": 1,
// 		"default_declaration_text1": null,
// 		"vat_no": "3",
// 		"creditor_no": "234",
// 		"iban": "kaban",
// 		"last_name": "Hater",
// 		"main_promoter": null,
// 		"vat_type_id": null,
// 		"account_holder": "Kuddus",
// 		"sortcode": "2143",
// 		"cost_payment_method_id": 3,
// 		"contact_id": 219,
// 		"invoice_discount_days": 14,
// 		"url3": null,
// 		"cost_discount_percent": "41.00",
// 		"mobile2": null,
// 		"email1": "bh@go-disko.de",
// 		"cost_discount_days": 23,
// 		"request": "",
// 		"tax_no": "34",
// 		"nick_name": "Greetings People"
// 	},
// 	"template_group_table": "/srv/www/htdocs/TEMPLATES/contacts_manage_contacts_related_groups.htm",
// 	"client": {
// 		"display_name": "details test account"
// 	},
// 	"action": "company_details",
// 	"related_groups": [
// 		{
// 			"group_name": "Paris",
// 			"group_id": "128"
// 		},
// 		{
// 			"group_id": "130",
// 			"group_name": "Promoter"
// 		},
// 		{
// 			"group_name": "Test Bug Venue Relation",
// 			"group_id": "163"
// 		},
// 		{
// 			"group_id": "161",
// 			"group_name": "Toulouse & Paris Contacts"
// 		}
// 	],
// 	"payment_methods": [
// 		{
// 			"last_modified": "0000-00-00 00:00:00",
// 			"auto_paid": null,
// 			"payment_method_name": "Wire Transfer",
// 			"created": "0000-00-00 00:00:00",
// 			"payment_method_id": "1"
// 		},
// 		{
// 			"payment_method_name": "Credit Card",
// 			"payment_method_id": "2",
// 			"created": "0000-00-00 00:00:00",
// 			"last_modified": "0000-00-00 00:00:00",
// 			"auto_paid": null
// 		},
// 		{
// 			"last_modified": "0000-00-00 00:00:00",
// 			"auto_paid": null,
// 			"payment_method_name": "Direct Debit",
// 			"payment_method_id": "3",
// 			"created": "0000-00-00 00:00:00"
// 		},
// 		{
// 			"payment_method_name": "Paypal",
// 			"created": "0000-00-00 00:00:00",
// 			"payment_method_id": "4",
// 			"auto_paid": null,
// 			"last_modified": "0000-00-00 00:00:00"
// 		},
// 		{
// 			"payment_method_name": "Cash",
// 			"created": "0000-00-00 00:00:00",
// 			"payment_method_id": "5",
// 			"auto_paid": null,
// 			"last_modified": "0000-00-00 00:00:00"
// 		},
// 		{
// 			"payment_method_id": "6",
// 			"created": "0000-00-00 00:00:00",
// 			"payment_method_name": "Invoice",
// 			"last_modified": "0000-00-00 00:00:00",
// 			"auto_paid": null
// 		},
// 		{
// 			"payment_method_id": "7",
// 			"created": "0000-00-00 00:00:00",
// 			"payment_method_name": "Cheque",
// 			"auto_paid": null,
// 			"last_modified": "0000-00-00 00:00:00"
// 		},
// 		{
// 			"last_modified": "0000-00-00 00:00:00",
// 			"auto_paid": null,
// 			"payment_method_name": "Prepayment",
// 			"payment_method_id": "8",
// 			"created": "0000-00-00 00:00:00"
// 		}
// 	],
// 	"contact_relations_template_type": "standard",
// 	"booking": "0",
// 	"countries": [
// 		"Afghanistan",
// 		"Aland Islands",
// 		"Albania",
// 		"Algeria",
// 		"American Samoa",
// 		"Andorra",
// 		"Angola",
// 		"Anguilla",
// 		"Antigua and Barbuda",
// 		"Argentina",
// 		"Armenia",
// 		"Aruba",
// 		"Australia",
// 		"Austria",
// 		"Azerbaijan",
// 		"Bahamas",
// 		"Bahrain",
// 		"Bangladesh",
// 		"Barbados",
// 		"Belarus",
// 		"Belgium",
// 		"Belize",
// 		"Benin",
// 		"Bermuda",
// 		"Bhutan",
// 		"Bolivia",
// 		"Bonaire, Saint Eustatius and Saba",
// 		"Bosnia and Herzegovina",
// 		"Botswana",
// 		"Brazil",
// 		"British Indian Ocean Territory",
// 		"British Virgin Islands",
// 		"Brunei Darussalam",
// 		"Bulgaria",
// 		"Burkina Faso",
// 		"Burundi",
// 		"Cambodia",
// 		"Cameroon",
// 		"Canada",
// 		"Cape Verde",
// 		"Cayman Islands",
// 		"Central African Republic",
// 		"Chad",
// 		"Chile",
// 		"China",
// 		"Christmas Island",
// 		"Cocos (Keeling) Islands",
// 		"Colombia",
// 		"Comoros",
// 		"Congo",
// 		"Congo, The Democratic Republic of the",
// 		"Cook Islands",
// 		"Costa Rica",
// 		"Cote D'Ivoire",
// 		"Croatia",
// 		"Cuba",
// 		"CuraÁao",
// 		"Cyprus",
// 		"Czech Republic",
// 		"Denmark",
// 		"Djibouti",
// 		"Dominica",
// 		"Dominican Republic",
// 		"Ecuador",
// 		"Egypt",
// 		"El Salvador",
// 		"Equatorial Guinea",
// 		"Eritrea",
// 		"Estonia",
// 		"Ethiopia",
// 		"Falkland Islands",
// 		"Faroe Islands",
// 		"Fiji",
// 		"Finland",
// 		"France",
// 		"French Guiana",
// 		"French Polynesia",
// 		"Gabon",
// 		"Gambia",
// 		"Georgia",
// 		"Germany",
// 		"Ghana",
// 		"Gibraltar",
// 		"Greece",
// 		"Greenland",
// 		"Grenada",
// 		"Guadeloupe",
// 		"Guam",
// 		"Guatemala",
// 		"Guernsey",
// 		"Guinea",
// 		"Guinea-Bissau",
// 		"Guyana",
// 		"Haiti",
// 		"Honduras",
// 		"Hong Kong",
// 		"Hungary",
// 		"Iceland",
// 		"India",
// 		"Indonesia",
// 		"Iran, Islamic Republic of",
// 		"Iraq",
// 		"Ireland",
// 		"Isle of Man",
// 		"Israel",
// 		"Italy",
// 		"Jamaica",
// 		"Japan",
// 		"Jersey",
// 		"Jordan",
// 		"Kazakhstan",
// 		"Kenya",
// 		"Kiribati",
// 		"Korea, Republic of",
// 		"Kosovo",
// 		"Kuwait",
// 		"Kyrgyzstan",
// 		"Lao People's Democratic Republic",
// 		"Latvia",
// 		"Lebanon",
// 		"Lesotho",
// 		"Liberia",
// 		"Libyan Arab Jamahiriya",
// 		"Liechtenstein",
// 		"Lithuania",
// 		"Luxembourg",
// 		"Macao",
// 		"Macedonia, the Former Yugoslav Republic of",
// 		"Madagascar",
// 		"Malawi",
// 		"Malaysia",
// 		"Maldives",
// 		"Mali",
// 		"Malta",
// 		"Marshall Islands",
// 		"Martinique",
// 		"Mauritania",
// 		"Mauritius",
// 		"Mayotte",
// 		"Mexico",
// 		"Micronesia",
// 		"Moldova, Republic of",
// 		"Monaco",
// 		"Mongolia",
// 		"Montenegro",
// 		"Montserrat",
// 		"Morocco",
// 		"Mozambique",
// 		"Myanmar",
// 		"Namibia",
// 		"Nauru",
// 		"Nepal",
// 		"Netherlands",
// 		"Netherlands Antilles",
// 		"New Caledonia",
// 		"New Zealand",
// 		"Nicaragua",
// 		"Niger",
// 		"Nigeria",
// 		"Niue",
// 		"Norfolk Island",
// 		"North Korea",
// 		"Northern Mariana Islands",
// 		"Norway",
// 		"Oman",
// 		"Pakistan",
// 		"Palau",
// 		"Palestinian Territory",
// 		"Panama",
// 		"Papua New Guinea",
// 		"Paraguay",
// 		"Peru",
// 		"Philippines",
// 		"Pitcairn",
// 		"Poland",
// 		"Portugal",
// 		"Puerto Rico",
// 		"Qatar",
// 		"Reunion",
// 		"Romania",
// 		"Russian Federation",
// 		"Rwanda",
// 		"Saint BarthÈlemy",
// 		"Saint Helena, Ascension and Tristan da Cunha",
// 		"Saint Kitts and Nevis",
// 		"Saint Lucia",
// 		"Saint Martin (French part)",
// 		"Saint Pierre and Miquelon",
// 		"Saint Vincent and the Grenadines",
// 		"Samoa",
// 		"San Marino",
// 		"Sao Tome and Principe",
// 		"Saudi Arabia",
// 		"Senegal",
// 		"Serbia",
// 		"Seychelles",
// 		"Sierra Leone",
// 		"Singapore",
// 		"Sint Maarten (Dutch part)",
// 		"Slovakia",
// 		"Slovenia",
// 		"Solomon Islands",
// 		"Somalia",
// 		"South Africa",
// 		"Spain",
// 		"Sri Lanka",
// 		"Sudan",
// 		"Suriname",
// 		"Svalbard and Jan Mayen",
// 		"Swaziland",
// 		"Sweden",
// 		"Switzerland",
// 		"Syrian Arab Republic",
// 		"Taiwan",
// 		"Tajikistan",
// 		"Tanzania, United Republic of",
// 		"Thailand",
// 		"Timor-Leste",
// 		"Togo",
// 		"Tokelau",
// 		"Tonga",
// 		"Trinidad and Tobago",
// 		"Tunisia",
// 		"Turkey",
// 		"Turkmenistan",
// 		"Turks and Caicos Islands",
// 		"Tuvalu",
// 		"Uganda",
// 		"Ukraine",
// 		"United Arab Emirates",
// 		"United Kingdom",
// 		"United States",
// 		"United States Minor Outlying Islands",
// 		"Uruguay",
// 		"Uzbekistan",
// 		"Vanuatu",
// 		"Vatican City State",
// 		"Venezuela",
// 		"Vietnam",
// 		"Virgin Islands, U.S.",
// 		"Wallis and Futuna",
// 		"Western Sahara",
// 		"Yemen",
// 		"Zambia",
// 		"Zimbabwe"
// 	],
// 	"contact_relations": [],
// 	"contact_search_type": "individual",
// 	"file_relation_external_id": "219",
// 	"currencies": [
// 		{
// 			"currency_sign": "$",
// 			"currency_minus_leading": null,
// 			"currency_minus_trailing": null,
// 			"currency_k_sep": null,
// 			"currency_sign_type": null,
// 			"exchange_rate": "1.5954",
// 			"currency_name": "Australian%252520Dollar",
// 			"currency_id": "5",
// 			"currency_d_sep": null,
// 			"currency_iso": "AUD",
// 			"created": "0000-00-00 00:00:00",
// 			"currency_decimals": null,
// 			"last_modified": "2019-01-30 10:55:35"
// 		},
// 		{
// 			"currency_k_sep": null,
// 			"currency_minus_leading": null,
// 			"currency_minus_trailing": null,
// 			"currency_sign": null,
// 			"currency_decimals": null,
// 			"last_modified": "2019-01-30 10:55:35",
// 			"currency_d_sep": null,
// 			"currency_iso": "BRL",
// 			"created": "2012-04-19 17:20:01",
// 			"exchange_rate": "4.2735",
// 			"currency_id": "24",
// 			"currency_name": "Brazilian%20Real",
// 			"currency_sign_type": null
// 		},
// 		{
// 			"created": "2015-08-21 16:38:03",
// 			"currency_iso": "CAD",
// 			"currency_d_sep": null,
// 			"last_modified": "2019-01-30 10:55:35",
// 			"currency_decimals": null,
// 			"currency_sign_type": null,
// 			"currency_id": "32",
// 			"currency_name": "Canadian%20Dollars",
// 			"exchange_rate": "1.5142",
// 			"currency_k_sep": null,
// 			"currency_sign": null,
// 			"currency_minus_trailing": null,
// 			"currency_minus_leading": null
// 		},
// 		{
// 			"last_modified": "2019-01-30 10:55:35",
// 			"currency_decimals": null,
// 			"created": "0000-00-00 00:00:00",
// 			"currency_iso": "CHF",
// 			"currency_d_sep": null,
// 			"currency_name": "Swiss Franc",
// 			"currency_id": "4",
// 			"exchange_rate": "1.1352",
// 			"currency_sign_type": null,
// 			"currency_k_sep": null,
// 			"currency_minus_trailing": null,
// 			"currency_minus_leading": null,
// 			"currency_sign": "CHF"
// 		},
// 		{
// 			"currency_sign": "¥",
// 			"currency_minus_leading": null,
// 			"currency_minus_trailing": null,
// 			"currency_k_sep": null,
// 			"currency_sign_type": null,
// 			"exchange_rate": "7.6927",
// 			"currency_id": "7",
// 			"currency_name": "Chinese Yuan",
// 			"currency_d_sep": null,
// 			"currency_iso": "CNY",
// 			"created": "0000-00-00 00:00:00",
// 			"currency_decimals": null,
// 			"last_modified": "2019-01-30 10:55:35"
// 		},
// 		{
// 			"currency_sign": "€",
// 			"currency_minus_leading": null,
// 			"currency_minus_trailing": null,
// 			"currency_k_sep": null,
// 			"currency_sign_type": null,
// 			"exchange_rate": "1",
// 			"currency_name": "EURO",
// 			"currency_id": "2",
// 			"currency_d_sep": null,
// 			"created": "2007-07-30 10:22:03",
// 			"currency_iso": "EUR",
// 			"currency_decimals": null,
// 			"last_modified": "2018-03-05 17:43:10"
// 		},
// 		{
// 			"currency_sign": "£",
// 			"currency_minus_trailing": null,
// 			"currency_minus_leading": null,
// 			"currency_k_sep": null,
// 			"currency_sign_type": null,
// 			"currency_name": "British%20Pounds",
// 			"currency_id": "3",
// 			"exchange_rate": "0.86735",
// 			"currency_iso": "GBP",
// 			"created": "0000-00-00 00:00:00",
// 			"currency_d_sep": null,
// 			"last_modified": "2019-01-30 10:55:36",
// 			"currency_decimals": null
// 		},
// 		{
// 			"currency_decimals": null,
// 			"last_modified": "2019-01-30 10:55:36",
// 			"currency_d_sep": null,
// 			"currency_iso": "HKD",
// 			"created": "0000-00-00 00:00:00",
// 			"exchange_rate": "8.962",
// 			"currency_id": "10",
// 			"currency_name": "Hong Kong Dollar",
// 			"currency_sign_type": null,
// 			"currency_k_sep": null,
// 			"currency_minus_leading": null,
// 			"currency_minus_trailing": null,
// 			"currency_sign": "$"
// 		},
// 		{
// 			"created": "2010-08-19 14:19:12",
// 			"currency_iso": "JPY",
// 			"currency_d_sep": null,
// 			"last_modified": "2019-01-30 10:55:36",
// 			"currency_decimals": null,
// 			"currency_sign_type": null,
// 			"currency_id": "27",
// 			"currency_name": "Japan Yen",
// 			"exchange_rate": "125.03",
// 			"currency_k_sep": null,
// 			"currency_sign": "¥",
// 			"currency_minus_trailing": null,
// 			"currency_minus_leading": null
// 		},
// 		{
// 			"currency_sign_type": null,
// 			"currency_name": "Mexican%20Peso",
// 			"currency_id": "31",
// 			"exchange_rate": "21.7153",
// 			"currency_iso": "MXN",
// 			"created": "2015-05-26 19:19:56",
// 			"currency_d_sep": null,
// 			"last_modified": "2019-01-30 10:55:36",
// 			"currency_decimals": null,
// 			"currency_sign": null,
// 			"currency_minus_trailing": null,
// 			"currency_minus_leading": null,
// 			"currency_k_sep": null
// 		},
// 		{
// 			"currency_d_sep": "",
// 			"currency_iso": "NZD",
// 			"created": "0000-00-00 00:00:00",
// 			"currency_decimals": null,
// 			"last_modified": "2019-01-30 10:55:36",
// 			"currency_sign_type": null,
// 			"exchange_rate": "1.6694",
// 			"currency_name": "New Zealand Dollars",
// 			"currency_id": "6",
// 			"currency_k_sep": "",
// 			"currency_sign": null,
// 			"currency_minus_leading": null,
// 			"currency_minus_trailing": null
// 		},
// 		{
// 			"currency_k_sep": null,
// 			"currency_sign": null,
// 			"currency_minus_trailing": null,
// 			"currency_minus_leading": null,
// 			"created": "0000-00-00 00:00:00",
// 			"currency_iso": "NZD",
// 			"currency_d_sep": null,
// 			"last_modified": "2019-01-30 10:55:36",
// 			"currency_decimals": null,
// 			"currency_sign_type": null,
// 			"currency_name": "New Zealand Dollar",
// 			"currency_id": "14",
// 			"exchange_rate": "1.6694"
// 		},
// 		{
// 			"currency_sign": null,
// 			"currency_minus_leading": null,
// 			"currency_minus_trailing": null,
// 			"currency_k_sep": null,
// 			"currency_sign_type": null,
// 			"exchange_rate": "75.6887",
// 			"currency_name": "Russian Rouble",
// 			"currency_id": "15",
// 			"currency_d_sep": null,
// 			"currency_iso": "RUB",
// 			"created": "0000-00-00 00:00:00",
// 			"currency_decimals": null,
// 			"last_modified": "2019-01-30 10:55:36"
// 		},
// 		{
// 			"currency_k_sep": null,
// 			"currency_sign": "kr",
// 			"currency_minus_trailing": null,
// 			"currency_minus_leading": null,
// 			"currency_iso": "SEK",
// 			"created": "0000-00-00 00:00:00",
// 			"currency_d_sep": null,
// 			"last_modified": "2019-01-30 10:55:36",
// 			"currency_decimals": null,
// 			"currency_sign_type": null,
// 			"currency_id": "16",
// 			"currency_name": "Swedish Krona",
// 			"exchange_rate": "10.3508"
// 		},
// 		{
// 			"currency_sign": null,
// 			"currency_minus_leading": null,
// 			"currency_minus_trailing": null,
// 			"currency_k_sep": null,
// 			"currency_sign_type": null,
// 			"exchange_rate": "6.0665",
// 			"currency_id": "36",
// 			"currency_name": "Turkish%25252520Lira",
// 			"currency_d_sep": null,
// 			"created": "2017-10-10 10:40:53",
// 			"currency_iso": "TRY",
// 			"currency_decimals": null,
// 			"last_modified": "2019-01-30 10:55:36"
// 		},
// 		{
// 			"currency_k_sep": null,
// 			"currency_minus_leading": null,
// 			"currency_minus_trailing": null,
// 			"currency_sign": "$",
// 			"currency_decimals": null,
// 			"last_modified": "2019-01-30 10:55:37",
// 			"currency_d_sep": null,
// 			"created": "2018-04-05 04:34:54",
// 			"currency_iso": "USD",
// 			"exchange_rate": "1.1422",
// 			"currency_name": "US%2525252525252520Dollars",
// 			"currency_id": "1",
// 			"currency_sign_type": null
// 		},
// 		{
// 			"currency_sign_type": null,
// 			"currency_name": "South%20African%20Rand",
// 			"currency_id": "33",
// 			"exchange_rate": "15.556",
// 			"currency_iso": "ZAR",
// 			"created": "2016-05-16 15:39:31",
// 			"currency_d_sep": null,
// 			"last_modified": "2019-01-30 10:55:37",
// 			"currency_decimals": null,
// 			"currency_sign": null,
// 			"currency_minus_trailing": null,
// 			"currency_minus_leading": null,
// 			"currency_k_sep": null
// 		}
// 	],
// 	"tax_types": [
// 		{
// 			"tax_deduction_flag": "1",
// 			"vat_type": "1",
// 			"tax_rate_percent": "19.000",
// 			"target_country": "United Kingdom",
// 			"created": "2010-07-09 14:13:07",
// 			"last_modified": "2019-05-03 09:14:22",
// 			"tax_name": "19% VAT",
// 			"tax_description": "19% VAT",
// 			"tax_type_id": "14"
// 		},
// 		{
// 			"tax_type_id": "1",
// 			"tax_description": "7% VAT",
// 			"tax_name": "7% VAT",
// 			"last_modified": "2015-05-21 21:00:17",
// 			"created": "2009-06-28 16:20:47",
// 			"tax_rate_percent": "7.000",
// 			"target_country": "Germany",
// 			"vat_type": "2",
// 			"tax_deduction_flag": "0"
// 		},
// 		{
// 			"last_modified": "2015-02-02 16:46:05",
// 			"created": "2015-02-02 16:44:11",
// 			"tax_rate_percent": "-19.000",
// 			"target_country": null,
// 			"vat_type": null,
// 			"tax_deduction_flag": "1",
// 			"tax_type_id": "27",
// 			"tax_description": "IRPF 19%",
// 			"tax_name": "IRPF 19%"
// 		},
// 		{
// 			"tax_type_id": "32",
// 			"tax_description": "Italian VAT ",
// 			"tax_name": "Italian VAT ",
// 			"last_modified": "2018-08-31 14:19:05",
// 			"tax_rate_percent": "21.000",
// 			"target_country": null,
// 			"created": "2016-02-16 17:41:10",
// 			"tax_deduction_flag": "0",
// 			"vat_type": "0"
// 		},
// 		{
// 			"vat_type": "0",
// 			"tax_deduction_flag": "0",
// 			"created": "2010-05-06 11:02:28",
// 			"target_country": "",
// 			"tax_rate_percent": "0.000",
// 			"last_modified": "2019-05-03 09:14:47",
// 			"tax_name": "no VAT",
// 			"tax_description": "no VAT",
// 			"tax_type_id": "13"
// 		},
// 		{
// 			"tax_deduction_flag": "1",
// 			"vat_type": null,
// 			"target_country": null,
// 			"tax_rate_percent": "0.000",
// 			"created": "2014-03-06 16:44:28",
// 			"last_modified": "2014-03-06 16:44:47",
// 			"tax_name": "Physical EU",
// 			"tax_description": "Tonträgerverkauf EU, steuerfreie Innergemeinschaftlicher Lieferung § 4 Nr.1a  USTG",
// 			"tax_type_id": "22"
// 		},
// 		{
// 			"last_modified": "2018-08-31 14:19:20",
// 			"created": "2016-05-16 15:51:35",
// 			"target_country": null,
// 			"tax_rate_percent": "14.000",
// 			"vat_type": "0",
// 			"tax_deduction_flag": "0",
// 			"tax_type_id": "33",
// 			"tax_description": "South African VAT",
// 			"tax_name": "South African VAT"
// 		},
// 		{
// 			"tax_deduction_flag": "0",
// 			"vat_type": "0",
// 			"last_modified": "2019-05-03 11:59:30",
// 			"tax_rate_percent": "21.000",
// 			"target_country": null,
// 			"created": "2013-08-08 07:29:54",
// 			"tax_description": "Spain VAT",
// 			"tax_name": "Spain VAT",
// 			"tax_type_id": "21"
// 		}
// 	],
// 	"external_id": "219",
// 	"documents": [],
// 	"files": [
// 		{
// 			"file_name": "CR05602.jpg",
// 			"file_description": "Audio Salad File of CR05602",
// 			"file_relation_id": "11246",
// 			"md": "2ee27b8f1b502ac1d0473c452848bdfe",
// 			"public": "1",
// 			"last_modified": "2019-02-05 12:11:52",
// 			"file_path": "http://api.audiosalad.com/image.php?id=706&size=1024&g_profile=syntax.audiosalad.com",
// 			"file_id": "3683",
// 			"file_type": "image/jpeg"
// 		},
// 		{
// 			"file_id": "920",
// 			"file_type": null,
// 			"public": "1",
// 			"last_modified": "2014-06-04 12:42:53",
// 			"file_path": null,
// 			"md": "bfcc99b0bba7a976d9f7fbc238186f83",
// 			"file_name": "details-logo.jpg",
// 			"file_description": "Details logo",
// 			"file_relation_id": "11243"
// 		},
// 		{
// 			"file_type": "image/jpeg",
// 			"file_id": "3682",
// 			"last_modified": "2019-02-05 12:09:49",
// 			"file_path": "http://api.audiosalad.com/image.php?id=705&size=1024&g_profile=syntax.audiosalad.com",
// 			"public": "1",
// 			"md": "6527ff3cb9e72ad80321959d8be7ba66",
// 			"file_name": "HR16832.jpg",
// 			"file_description": "Audio Salad File of HR16832",
// 			"file_relation_id": "11245"
// 		},
// 		{
// 			"md": "df69762a0d6d2ee4fc6044f1b5e3a7c0",
// 			"file_relation_id": "11244",
// 			"file_name": "kala.png",
// 			"file_description": null,
// 			"file_type": null,
// 			"file_id": "922",
// 			"file_path": null,
// 			"last_modified": "2014-06-12 13:50:52",
// 			"public": "1"
// 		}
// 	],
// 	"label": "1",
// 	"languages": [
// 		[
// 			"en",
// 			"English"
// 		],
// 		[
// 			"be",
// 			"BEnglish"
// 		],
// 		[
// 			"de",
// 			"German"
// 		],
// 		[
// 			"fr",
// 			"French"
// 		],
// 		[
// 			"it",
// 			"Italian"
// 		],
// 		[
// 			"es",
// 			"Spanish"
// 		],
// 		[
// 			"nl",
// 			"Dutch"
// 		],
// 		[
// 			"pt",
// 			"Portuguese"
// 		],
// 		[
// 			"tr",
// 			"Turkish"
// 		]
// 	],
// 	"promoter": null,
// 	"template_documents_table": "/srv/www/htdocs/TEMPLATES/contacts_manage_contacts_related_contact_documents.htm",
// 	"template_contact_files": "/srv/www/htdocs/TEMPLATES/booking_calendar_documents_table.htm",
// 	"contact_id": "219",
// 	"related_documents": [
// 		{
// 			"file_name": "CR05602.jpg",
// 			"file_description": "Audio Salad File of CR05602",
// 			"file_relation_id": "11246",
// 			"md": "2ee27b8f1b502ac1d0473c452848bdfe",
// 			"public": "1",
// 			"last_modified": "2019-02-05 12:11:52",
// 			"file_path": "http://api.audiosalad.com/image.php?id=706&size=1024&g_profile=syntax.audiosalad.com",
// 			"file_id": "3683",
// 			"file_type": "image/jpeg"
// 		},
// 		{
// 			"file_id": "920",
// 			"file_type": null,
// 			"public": "1",
// 			"last_modified": "2014-06-04 12:42:53",
// 			"file_path": null,
// 			"md": "bfcc99b0bba7a976d9f7fbc238186f83",
// 			"file_name": "details-logo.jpg",
// 			"file_description": "Details logo",
// 			"file_relation_id": "11243"
// 		},
// 		{
// 			"file_type": "image/jpeg",
// 			"file_id": "3682",
// 			"last_modified": "2019-02-05 12:09:49",
// 			"file_path": "http://api.audiosalad.com/image.php?id=705&size=1024&g_profile=syntax.audiosalad.com",
// 			"public": "1",
// 			"md": "6527ff3cb9e72ad80321959d8be7ba66",
// 			"file_name": "HR16832.jpg",
// 			"file_description": "Audio Salad File of HR16832",
// 			"file_relation_id": "11245"
// 		},
// 		{
// 			"md": "df69762a0d6d2ee4fc6044f1b5e3a7c0",
// 			"file_relation_id": "11244",
// 			"file_name": "kala.png",
// 			"file_description": null,
// 			"file_type": null,
// 			"file_id": "922",
// 			"file_path": null,
// 			"last_modified": "2014-06-12 13:50:52",
// 			"public": "1"
// 		}
// 	],
// 	"additional_infos": [],
// 	"fields": [
// 		{
// 			"custom_data_id": "14757",
// 			"external_id": "219",
// 			"data": "Tag is here",
// 			"field_label": "test tag",
// 			"custom_field_id": "580",
// 			"external_table": "contacts",
// 			"last_modified": "2019-05-09 14:48:01",
// 			"created": "2019-05-09 12:14:13"
// 		},
// 		{
// 			"data": "herb is good",
// 			"external_id": "219",
// 			"custom_data_id": "14758",
// 			"created": "2019-05-09 12:14:13",
// 			"last_modified": "2019-05-09 14:48:06",
// 			"external_table": "contacts",
// 			"custom_field_id": "592",
// 			"field_label": "Hébergement"
// 		},
// 		{
// 			"custom_field_id": "594",
// 			"last_modified": "2019-05-09 14:48:09",
// 			"external_table": "contacts",
// 			"created": "2019-05-09 12:14:13",
// 			"field_label": "Colégio",
// 			"data": "collage",
// 			"custom_data_id": "14759",
// 			"external_id": "219"
// 		},
// 		{
// 			"created": "2019-05-09 12:14:13",
// 			"custom_field_id": "595",
// 			"last_modified": "2019-05-09 14:48:13",
// 			"external_table": "contacts",
// 			"field_label": "Associação",
// 			"data": "assoax",
// 			"external_id": "219",
// 			"custom_data_id": "14760"
// 		}
// 	]
// };

//#endregion